import type { NewUserQuizCopy } from '../types';

export const ES_NEW_USER_QUIZ_COPY = {
  booking: {
    backToVideo: 'Volver a tu video',
    bookedSnackbar: 'Tu demo está reservada. ¡Nos vemos!',
    bullets: {
      pricing: 'Precios claros según el volumen y el nivel de soporte',
      teams: 'Diseñado para equipos: revisores, glosarios y una única biblioteca',
      setup: 'Descubre la configuración adecuada para tu contenido y flujo de trabajo',
    },
    confirmation: {
      title: 'Tu demo está reservada',
      description:
        'Se ha enviado una invitación de calendario a tu correo electrónico. Tu vista previa localizada seguirá disponible para compartir antes de la llamada.',
    },
    continue: 'Continuar',
    decision: {
      bookDemo: {
        title: 'Reservar una demo',
        buttonLabel: 'Reservar una demo',
        description:
          'Revisa con un especialista los espacios de trabajo en equipo, la API y el doblaje a gran escala, y define cómo encaja Rask en tu flujo.',
      },
      exploreEditor: {
        title: 'Explorar en el editor',
        buttonLabel: 'Abrir el editor',
        description:
          'Ajusta por tu cuenta el guion, las voces y los tiempos. Todo está desbloqueado durante tu prueba.',
      },
    },
    description: 'Te ayudamos a configurar Rask según tu contenido, tu equipo y tu volumen.',
    followUp: {
      callAgenda: [
        'Un vistazo rápido a la vista previa que has creado',
        'Tu flujo de trabajo, volumen y plan de lanzamiento',
        'Configuramos el editor según tu flujo de trabajo',
      ],
      callDescription: 'Consulta en la invitación de calendario la fecha, la hora y el enlace confirmados.',
      callDurationLabel: (minutes) => `Videollamada de ${minutes} minutos`,
      callTitle: 'Tu llamada',
      manageBooking: {
        title: 'Gestionar tu reserva',
        buttonLabel: 'Gestionar reserva',
        closeLabel: 'Cerrar',
        description:
          'Para cambiar o cancelar la reunión, abre el evento en tu calendario corporativo y utiliza las opciones de la invitación.',
        googleCalendarLabel: 'Abrir Google Calendar corporativo',
        outlookCalendarLabel: 'Abrir el calendario corporativo de Outlook',
      },
      prepareDescription: 'Invita a tus compañeros y anota los cambios de texto, voz o tiempos que quieras comentar.',
      prepareTitle: 'Prepárate para la llamada',
      share: {
        title: 'Comparte esta vista previa con tu equipo',
        buttonLabel: 'Compartir',
        copiedButtonLabel: '¡Copiado!',
        copyButtonLabel: 'Copiar',
        description: 'Envía la vista previa localizada a tu equipo para que todos lleguen con comentarios útiles.',
        modalDescription: 'Envía tu vídeo a quien quieras con el siguiente enlace',
        modalTitle: 'Comparte tu vídeo',
      },
      videoCallLabel: 'Videollamada',
    },
    heading: 'Reserva tu llamada de configuración',
    headingSecondLine: '',
    maybeLater: 'Quizá más tarde',
    persistenceError: 'No hemos podido guardar este paso. Selecciona «Continuar» para volver a intentarlo.',
    rating: '4,7/5 en G2',
    scheduler: {
      fallbackBookedLabel: 'Ya reservé una cita',
      openBookingPage: 'Abrir página de reserva',
      loadErrorDescription:
        'Es posible que tu red o región esté bloqueando el contenido insertado. Abre la página de reserva en una pestaña nueva.',
      loadErrorTitle: 'No se ha podido cargar el calendario',
      loadingLabel: 'Cargando el calendario',
    },
    trustedBy: 'Equipos de todo el mundo confían en Rask',
    verificationPending: {
      title: 'Estamos confirmando tu reserva',
      description: 'Estamos comprobando los detalles de la reunión con HubSpot. Esto puede tardar unos instantes.',
    },
  },
  controls: {
    back: 'Atrás',
    continue: 'Continuar',
    continueAnyway: 'Continuar de todos modos',
    progress: (currentStep, totalSteps) => `Pregunta ${currentStep} de ${totalSteps}`,
    submitError: 'No hemos podido guardar tus respuestas. Inténtalo de nuevo.',
  },
  priorityQuestion: {
    title: '¿Cuál es tu prioridad de localización ahora mismo?',
    audioTitle: '¿Cuál es tu prioridad de localización ahora mismo?',
    options: {
      collaborate_with_team_or_reviewers: { label: 'Control de calidad y flujo de trabajo' },
      consistent_voice_and_terminology: { label: 'Voz y terminología coherentes' },
      fast_results_no_setup: { label: 'Trabajo individual sencillo y rápido' },
      integration_into_product_or_workflow: { label: 'Integración y cumplimiento' },
      not_sure_yet: { label: 'Todavía no lo tengo claro' },
    },
    subtitle: 'Elige una opción',
  },
  questions: {
    content_team_size: {
      title: '¿Cuántas personas de tu equipo trabajan con contenido de video?',
      options: {
        just_me: { label: '1' },
        large_team_5_plus: { label: '8+' },
        small_team_2_5: { label: '2-7' },
      },
    },
    localization_frequency: {
      title: '¿Con qué frecuencia localizas videos?',
      audioTitle: '¿Con qué frecuencia localizas contenido?',
      options: {
        continuously: { label: 'Tengo una necesidad constante' },
        occasionally_quarterly: { label: 'Ocasionalmente' },
        regularly_monthly: { label: 'Regularmente', description: 'Cada mes' },
        one_time_project: { label: 'Tengo una tarea puntual' },
      },
    },
  },
} satisfies NewUserQuizCopy;
